import { Component, OnDestroy, OnInit } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';
import { ConfigService } from 'esz-saas-lcp-ng-crud-ui';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'app-ws-topbar',
    templateUrl: './ws-topbar.component.html'
})
export class WsTopbarComponent implements OnInit, OnDestroy {
    /** Phone menu state. Closed on every navigation so a tapped link never leaves it open over the page. */
    menuOpen = false;

    readonly links = [
        { path: '/', label: 'HOME', exact: true },
        { path: '/aboutus', label: 'ABOUT US', exact: false },
        { path: '/services', label: 'SERVICES', exact: false },
        { path: '/free-software', label: 'FREE SOFTWARE', exact: false },
        { path: '/snapcart', label: 'SNAPCART', exact: false }
    ];

    private navigation?: Subscription;

    constructor(public configService: ConfigService, private router: Router) { }

    ngOnInit(): void {
        this.navigation = this.router.events
            .pipe(filter(e => e instanceof NavigationEnd))
            .subscribe(() => this.menuOpen = false);
    }

    ngOnDestroy(): void {
        this.navigation?.unsubscribe();
    }
}
